<template>
  <CardToggle :label="$t('global.auto-scaling')">
    <template #toggle>
      <Toggle
        v-model="site.environment.options.autoScaleEnabled"
        @change="onToggle"
        :transitioning="isSubmitting"
        :disabled="disabled"
      />
    </template>
    <template #description>
      <Alert
        v-if="disabled"
        :message="$t('global.auto-scaling-disabled-message')"
        variant="info"
        :dismissible="false"
      />
      <p>{{ $t("global.auto-scaling-description-1") }}</p>
      <p>{{ $t("global.auto-scaling-description-2") }}</p>
      <div>
        {{ $t("global.auto-scaling-description-3") }}
        <ul>
          <li>{{ $t("global.auto-scaling-description-3-bullet-1") }}</li>
          <li>{{ $t("global.auto-scaling-description-3-bullet-2") }}</li>
          <li>{{ $t("global.auto-scaling-description-3-bullet-3") }}</li>
        </ul>
      </div>
      <AutoScaleUsage v-if="site.environment.options.autoScaleEnabled" :site="site" />
    </template>
  </CardToggle>
</template>

<script>
import Alert from "@/components/display/Alert";
import AutoScaleUsage from "@/components/smart/cards/AutoScaleUsage";
import CardToggle from "@/components/display/card-sub-components/CardToggle";
import { ref } from "@vue/composition-api";
import store from "@/store";
import Toggle from "@/components/display/Toggle";

export default {
  name: "AutoScaling",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      required: true,
    },
  },
  components: {
    AutoScaleUsage,
    CardToggle,
    Alert,
    Toggle,
  },
  setup(props, { root }) {
    const isSubmitting = ref(false);
    const onToggle = (enabled) => {
      isSubmitting.value = true;
      store
        .dispatch("sites/updateAutoScale", {
          id: props.site.id,
          data: { enabled },
        })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.auto-scale-change-success-message", {
              name: props.plan.isTShirt ? props.plan.nickname : site.domain,
              action: root.$t(enabled ? "global.enabled" : "global.disabled").toLowerCase(),
            }),
          });
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.auto-scale-change-error-message", {
              name: props.plan.isTShirt ? props.plan.nickname : site.domain,
              action: root.$t(enabled ? "global.enable" : "global.disable").toLowerCase(),
            }),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      isSubmitting,
      onToggle,
    };
  },
};
</script>
